var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCadenas(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Composant_197_1",
    "data-name": "Composant 197 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.719,
    height: 15.616,
    viewBox: "0 0 10.719 15.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_471",
    "data-name": "Trac\\xE9 471",
    d: "M341.467,351.29v-1.909a2.477,2.477,0,0,1,4.953,0v1.909h1.945v-1.909a4.421,4.421,0,0,0-8.843,0v1.909Z",
    transform: "translate(-338.584 -344.96)",
    fill: "#1b394c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_472",
    "data-name": "Trac\\xE9 472",
    d: "M348.368,352.2H339.52a.936.936,0,0,0-.936.936v6.5a.936.936,0,0,0,.936.935h8.848a.935.935,0,0,0,.935-.935v-6.5a.936.936,0,0,0-.935-.936M344.4,356.58v1.387a.458.458,0,0,1-.915,0V356.58a1.373,1.373,0,1,1,.915,0",
    transform: "translate(-338.584 -344.96)",
    fill: "#1b394c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_473",
    "data-name": "Trac\\xE9 473",
    d: "M343.487,355.22a.461.461,0,1,1,.385.526.461.461,0,0,1-.385-.526",
    transform: "translate(-338.584 -344.96)",
    fill: "#1b394c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadenas);
export default __webpack_public_path__ + "static/media/cadenas.12ef92f79aee8ba13c284f2c8ef1e7cb.svg";
export { ForwardRef as ReactComponent };